/** Iter 53 — pure helpers for the impact-graph edge legend (data comes from the API `legend`). */

/** SVG stroke props for a legend swatch — line style carries the meaning, colour is the tint. */
export function legendLineStyle(item) {
  const line = item?.line || "solid";
  return {
    stroke: item?.color || "#8d8d8d",
    strokeWidth: line === "thick" ? 3 : 1.5,
    strokeDasharray: line === "dotted" ? "4 3" : undefined,
  };
}

/** Human label for a legend entry (reference edges have no on-edge label). */
export function legendLabel(item) {
  if (!item) return "";
  return item.label || item.category;
}

/** Entries to draw, in vocabulary order as delivered; empty when the graph has no edges. */
export function legendItems(graph) {
  const items = graph?.legend?.edges;
  return Array.isArray(items) ? items.filter((i) => i && i.count > 0) : [];
}

/** Categories whose meaning is "no operation recorded / not classified" — get a fallback hint. */
export function isFallbackCategory(category) {
  return category === "reference" || category === "unknown";
}
